import { render, staticRenderFns } from "./NavBar.vue?vue&type=template&id=077e27e0&"
var script = {}
import style0 from "./NavBar.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports